import { render, staticRenderFns } from "./HorariosCanvas.vue?vue&type=template&id=3901a3d8&shadow"
import script from "./HorariosCanvas.vue?vue&type=script&lang=js&shadow"
export * from "./HorariosCanvas.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./HorariosCanvas.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports